import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "I love being a geek",
  "description": "",
  "published": "2013-04-23T00:00:00.000Z",
  "redirect_from": ["/blog/i-love-being-a-geek/swizec/6146"],
  "categories": "Enid Blyton, Famous Five, Geek, Geeks and Nerds, Subcultures, Uncategorized",
  "hero": "./img/2554-3817371960_1d173bd07f_z.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><a parentName="p" {...{
        "href": "http://www.flickr.com/photos/aaronbassett/3817371960/"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "640px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "56.05381165919282%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'225\\'%20viewBox=\\'0%200%20400%20225\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M231%2025v5l-8%201c-13%202-25%203-26%202h-8l-4%201c0%201-9%203-12%202-2%200-2%200-1%202%200%201%200%202-2%202v25c-1%204%200%205%201%206%202%201%202%203%202%209v8l1-7c0-11%202-12%2016-13h19l7-1%206%201a964%20964%200%2001-7%2038c4%200%203%2015-1%2018-3%202-18%202-34%200h-19l-22%201c-17%200-17-1-17%2015l-2%2020v9h-17c-16%200-17%200-18%202l-12%201-11%201c0%202%200%202%2017%202l6%201v4l-1%204-11-1-30-2-1-7c0-7%200-7%203-7l2-2-2-2c-2%200-2-1-2-5%200-5%200-6%202-6l2-2c-1-3-2-5-3-3l-2%202c-2%200-3%203-3%207%200%202%200%203-3%203-5%201-8%200-8-2l-2-1-2%202-2%201-2%201-2%203-2%201-2%202c-4%201-4%2013%200%2013l1-3%202-5%203-3%202-2%202-1c-1-2%202-3%205-2l3%202%201%202%202%202%202%202%202%205%201%206%202%202c1%202%202%202%2015%202%2027%200%2027%200%2027%202s3%203%2016%204a18968%2018968%200%2001197%205c17%201%2018%201%2018-1%201-2%201-2%201%200s0%202%2010%202h10v-11l1-34%201%207%201%207c1%201%203%200%203-2l1-1%201%2028c0%207%200%207%2012%207l6-1%205-1%206%201c0%201%2015%202%2019%201h5l-2-2-2-2-1-25a730%20730%200%2000-11-122l-1%2012v11c-1-2-4-2-6-1l-3-1-2-1v-2c-1-1-1-1-2%201-1%201-1%201-2-1l-1-2-1-1c0-3-10-9-16-10l-7-2c-4-2-29%202-31%204l2%201c18-6%2037-4%2045%203%203%202%202%202-3-1-6-2-25-2-30%200s-7%206-5%209c3%202%202%202-1%203l-2-1%201-1v-1h-4v-1c-1-1-2-2-1-3l-1-3-3%207-1%203-1%202v2l-3%201-5%201v7c0%2012%200%2012-6%2012h-5l-3%201c-3%201-3%200-3-1a1612%201612%200%200013-66c-1-1-31-6-55-8l-6-1-1%205m-82%2023l-7%201c-11-1-14%200-17%207-3%206-3%206-2%2010s2%205%209%209c10%206%2012%208%2010%2012s-4%205-8%205-10-5-10-7l-1-5-1-2-1%202-1%209c0%205%200%206%201%205h7c13%203%2023-3%2023-15%201-5-2-9-8-12-11-5-12-6-12-10%200-9%2014-8%2016%202%201%204%203%205%204%202v-2l-1-2%201-2%201-4c0-4-1-5-3-3m187%2038v21c1%2024%201%2021%202%2021l1-12-1-12v-2c2-1%202-2%201-2-2-1%200-8%201-8l1-2-1-3-1-1h2l2-1c0-2-6-1-7%201M85%20150l-1%203c0%202%200%202-4%202-3-1-3-1-3%201%201%202%201%202%209%202h5v4l-1%204-2%201h9l5-1c6%200%203-3-3-3-4-1-5-1-5-3s0-2%205-1c4%200%205%200%205-2l-4-1-8-1c-5%200-5%200-5-4%200-3-1-4-2-1m-40%2048c1%202%201%202-1%202h-5l-30-1-9-1v4l1%204v1l-1%205c0%205%200%205%203%206%204%200%205%200%203-2-3-3%200-8%204-7%202%201%203%201%202%207l-2%201c-2%200%200%203%206%205%204%203%2011%204%2010%202h6c31%201%2035%201%2035-1h2l-2-4v1c0%202%200%202-1%201l-3-4v-1l-2-3-2-3s-7-8-13-12h-1m13%203l1%203c4%204%207%209%2010%2015l3%206h328v-15h-14a1779%201779%200%2001-110-3%2029162%2029162%200%2001-218-6\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/3904feb11efbb7d760a16839b2f91f8f/ca0a1/2554-3817371960_1d173bd07f_z.webp 223w", "/static/3904feb11efbb7d760a16839b2f91f8f/75680/2554-3817371960_1d173bd07f_z.webp 445w", "/static/3904feb11efbb7d760a16839b2f91f8f/0ba47/2554-3817371960_1d173bd07f_z.webp 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/3904feb11efbb7d760a16839b2f91f8f/853b2/2554-3817371960_1d173bd07f_z.jpg 223w", "/static/3904feb11efbb7d760a16839b2f91f8f/0a4fe/2554-3817371960_1d173bd07f_z.jpg 445w", "/static/3904feb11efbb7d760a16839b2f91f8f/c08c5/2554-3817371960_1d173bd07f_z.jpg 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/jpeg"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/3904feb11efbb7d760a16839b2f91f8f/c08c5/2554-3817371960_1d173bd07f_z.jpg",
                "alt": "Geek shelf by Aaron Bassett",
                "title": "Geek shelf by Aaron Bassett",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Geek shelf by Aaron Bassett`}</figcaption>{`
  `}</figure></a></p>
    <p>{`I have always seen myself as a stereotypical geek. Kind of introverted, not very athletic, infinitely excitable about the strangest of things, spends more time with people on the internet than talking face-to-face, prefers it even.`}</p>
    <p>{`And I love being that. The infinite freedom that comes with being a geek is intoxicating.`}</p>
    <p>{`While normal people have to worry about keeping appearances, about maintaining a fine-knit web of social interaction through a series of carefully maintained half truths, I can just be myself. Because I'm a geek.`}</p>
    <p>{`People pretending they like certain things, pretending they care about this or that issue, just to fit in. Just so they'll be liked. As a geek I don't have to do any of that.`}</p>
    <p>{`As a geek I can shout at the top of my lungs `}<em parentName="p">{`"I don't understand football"`}</em>{` at the height of football fever during a world championship. Nobody minds, nobody laughs, they just explain the game. `}<em parentName="p">{`"Don't mind him, he's a geek you see, he doesn't get normal people stuff"`}</em></p>
    <p>{`When I was about ten years old I couldn't get enough of `}<a parentName="p" {...{
        "href": "http://www.amazon.com/Five-Treasure-Island-Famous/dp/0340796146%3FSubscriptionId%3D0G81C5DAZ03ZR9WH9X82%26tag%3Dageewitahat-20%26linkCode%3Dxm2%26camp%3D2025%26creative%3D165953%26creativeASIN%3D0340796146",
        "title": "Five on a Treasure Island (Famous Five)"
      }}>{`The Famous Five series`}</a>{` by `}<a parentName="p" {...{
        "href": "http://www.enidblytonsociety.co.uk",
        "title": "Enid Blyton"
      }}>{`Enid Blyton`}</a>{`. Library copies were always tattered to bits and that just made them better. I don't remember much, but I do remember one character clearly - The Scientist. He was `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/George_Kirrin",
        "title": "George Kirrin"
      }}>{`George`}</a>{`'s dad or uncle and his defining characteristic was that he was always kind of grumpy and locked up in his room where he was "doing science".`}</p>
    <p>{`Not to be bothered. Not to be disturbed. Not to even be thought about too loudly. Lunch was often taken to his room because he would forget to eat.`}</p>
    <p>{`Imagine that!`}</p>
    <p>{`A guy who gets peace and quiet to work. All summer. In a house full of 12 year olds. That's the power of being a geek.`}</p>
    <p>{`Geeks - the only people who get to truly be themselves even as adults. I love it! (said with my best Tennant impersonation)`}</p>
    <p>{`It's all starting to unravel for me though. People are suggesting I might want to "grow up" ... whatever that means.`}</p>
    <p>{`Just the other day someone mentioned I do a lot of sports. Ironically this happened at boxing practice; she spends 5 days a week there. A person who goes to practice 5 days a week thinks I do a lot of sports ... I have never been so confused.`}</p>
    <p>{`A few days later I had a call with someone looking for "somebody older" to be a technical lead. An old sage to look over the rabble of Stanford grads he's built a team out of. I'M TWENTY-FIVE!`}</p>
    <p>{`I hope it's not too late for me. Save yourselves! Be geeky!`}</p>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/?px",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=438c823e-3724-451f-9fb5-14ac805cded3",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      